import styled, { css } from 'styled-components';
import { getBrightInvertedColor } from '@elfsight/widget-utils';
import { APP_CLASSNAME_PREFIX } from '../../../../constants';

export const Badge = ({ data, isMobile }) => {
  const {
    contentBadgeText,
    contentBadgeColor,
    contentBadgeFontSize,
    contentBadgeStyle
  } = data;

  return (
    <Container>
      <StyledBadge
        $fontSize={isMobile ? 10 : contentBadgeFontSize}
        $color={contentBadgeColor}
        $style={contentBadgeStyle}
      >
        {contentBadgeText}
      </StyledBadge>
    </Container>
  );
};

const Container = styled.div.attrs({
  className: `${APP_CLASSNAME_PREFIX}-badge-container`
})`
  margin: 20px 0;
`;

const StyledBadge = styled.div.attrs({
  className: `${APP_CLASSNAME_PREFIX}-badge-component`
})`
  text-align: right;
  padding: 0.230769em 0.615384em;
  border-radius: 2px;
  box-sizing: border-box;
  display: inline-block;
  flex-grow: 0;
  text-transform: uppercase;
  line-height: 1.1;
  border-width: 1px;
  border-style: solid;
  font-size: ${({ $fontSize }) => `${$fontSize}px`};
  border-color: ${({ $color }) => $color};

  ${({ $style, $color }) =>
    $style === 'filled'
      ? css`
          background-color: ${$color};
          color: ${getBrightInvertedColor($color, [
            'rgb(255, 255, 255)',
            'rgb(29, 33, 41)'
          ])};
        `
      : css`
          background-color: transparent;
          color: ${$color};
        `}
`;
